import { createSlice } from '@reduxjs/toolkit';
import HbsHastaizlemDTO from 'src/models/IzlemGozlem/HbsHastaizlemDTO';
import VwHbshastaizlemDTO from 'src/models/IzlemGozlem/VwHbshastaizlemDTO';
import MapReducerPayloads from 'src/models/store/MapReducerPayloads';

// 1

interface HastaIzlemState {
  hastaIzlemDialogOpen: boolean;
  editHastaIzlemValues: VwHbshastaizlemDTO;
  refetchTrigger: boolean;
  grafikDialogOpen: boolean;
}

// 2
const initialState: HastaIzlemState = {
  hastaIzlemDialogOpen: false,
  editHastaIzlemValues: null,
  refetchTrigger: false,
  grafikDialogOpen: false
}

// 3
const HastaIzlemReducers = {
  setHastaIzlemDialogOpen: (state: HastaIzlemState, action) => {
    state.hastaIzlemDialogOpen = action.payload;
  },
  setEditHastaIzlemValues: (state: HastaIzlemState, action) => {
    state.editHastaIzlemValues = action.payload;
  },
  setRefetchTrigger: (state: HastaIzlemState, action) => {
    state.refetchTrigger = action.payload;
  },
  setGrafikDialogOpen: (state: HastaIzlemState, action) => {
    state.grafikDialogOpen = action.payload;
  },
  
}
const HastaIzlemSlice = createSlice<HastaIzlemState, MapReducerPayloads<HastaIzlemState, {
  // 4
  setHastaIzlemDialogOpen: boolean,
  setEditHastaIzlemValues: VwHbshastaizlemDTO,
  setRefetchTrigger: boolean,
  setGrafikDialogOpen: boolean
  
}>>({
  name: 'hastaIzlem',
  initialState,
  reducers: HastaIzlemReducers,
})

export default HastaIzlemSlice;
